module.exports = __webpack_public_path__ + "static/media/rsvp_main_ipad.0cd4aa5a.png";